import { useApolloClient } from "@apollo/client";
import { useEffect } from "react";

import { useVisibilityChange } from "@/hooks/useVisibilityChange";

export function useRefetchQueries() {
  const documentVisible = useVisibilityChange();
  const client = useApolloClient();

  useEffect(() => {
    if (client && documentVisible) {
      client.refetchQueries({ include: "active" });
    }
  }, [client, documentVisible]);
}
